// extracted by mini-css-extract-plugin
export default {"container":"MarkdownContent-module_container__mKTGe"};